import { useEffect, useState } from "react"
import { ICatalogoInseguro, IFormularioHazard, INivelRiesgo, IPersonaHazard, IPersonaReporte, actoConst, condicionConst, incidentesConst, nivelRiesgoConst } from "../../Interfaces/hazard/IHazard"
import { IItemComboBaseDTO } from "../../Interfaces/base/IBase"
import { GrupoIncidenteService } from "../../services/hazard/grupoIncidente"
import { Ifilter } from "../../Interfaces/filter"
import { NivelRiesgoService } from "../../services/hazard/nivelRiesgoService"
import { CatalogoInseguroService } from "../../services/hazard/catalogoInseguroService"
import UbicacionService from "../../services/auxiliar/UbicacionService"
import { IUbicacionRequest } from "../../Interfaces/auxiliar/IUbicacion"
import { EmpresaService } from "../../services/administracion/Empresa/EmpresaService"
import { HazardService } from "../../services/hazard/hazardService"
import personaServicio from "../../services/persona/personaServicio"
const getDate=()=>{
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
}
export const UseFormularioHazard=()=>{
    const initial:IFormularioHazard={
        incidenteId: undefined,
        titulo: "",
        descripcion: "",
        accionesInmediatas: "",
        ubicacionId: undefined,
        descripcionUbicacion: "",
        fecha: getDate(),
        nivelRiesgoId: "",
        razonRiesgo: "",
        nivelRiesgoAcordadoId: ""
    }
    const [request,setRequest] = useState<IFormularioHazard>(initial)
    const [hazardPersona,setHazardPersona]=useState<IPersonaHazard>({})
    const [incidentes,setIncidentes]=useState<IItemComboBaseDTO[]>([])
    const [condiciones,setCondiciones]=useState<IItemComboBaseDTO[]>([])
    const [actos,setActos]=useState<IItemComboBaseDTO[]>([])
    const [niveles,setNiveles]=useState<IItemComboBaseDTO[]>([])
    const [acordados,setAcordados]=useState<IItemComboBaseDTO[]>([])
    const [ubicaciones,setUbicaciones]=useState<IItemComboBaseDTO[]>([])
    const [empresas,setEmpresas]=useState<IItemComboBaseDTO[]>([])
    const [personas,setPersonas]=useState<IItemComboBaseDTO[]>([])
    const [empresaRequest,setEmpresaRequest]=useState<Ifilter>({
        skip: 0,
        take: 20,
        search:undefined,
    })
    
    const [personaSearch,setPersonaSearch]=useState<string>("")
    const [requestUbicacion,setRequestUbicacion]=useState<IUbicacionRequest>({
        skip: 0,
        take: 20,
        search:undefined,
        nivel:3,
        esCondicion:false
    })
    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const getIncidentes=()=>{
        const request:Ifilter={
            skip: 0,
            take: 20
        }
        GrupoIncidenteService.ComboGrupoIncidente(request).then((res)=>{
            if(res.status==200){
                setIncidentes(res.data)
            }
        }).catch(()=>{})
       
    }
    const getUbicaciones=()=>{
        UbicacionService.ComboUbicacion(requestUbicacion).then((res)=>{
            if(res.status==200){
                setUbicaciones(res.data)
            }
        }).catch(()=>{})
    }
    const getEmpresas=()=>{
        EmpresaService.ComboEmpresa(empresaRequest).then((res)=>{
            if(res.status==200){
                setEmpresas(res.data)
            }
        }).catch(()=>{})
    }
    const getCondiciones=()=>{
        const request:ICatalogoInseguro={
            skip: 0,
            take: 20,
            esCondicion: true
        }
        CatalogoInseguroService.ComboCatalogoInseguro(request).then((res)=>{
            if(res.status==200){
                setCondiciones(res.data)
            }
        }).catch(()=>{})
    }
    const getActos=()=>{
        const request:ICatalogoInseguro={
            skip: 0,
            take: 20,
            esCondicion: false
        }
        CatalogoInseguroService.ComboCatalogoInseguro(request).then((res)=>{
            if(res.status==200){
                setActos(res.data)
            }
        }).catch(()=>{})
        
    }
    const getNiveles=()=>{
        const request:INivelRiesgo={
            skip: 0,
            take: 20,
            esAcordado: false
        }
        NivelRiesgoService.ComboNivelRiesgo(request).then((res)=>{
            if(res.status==200){
                setNiveles(res.data)
            }
        }).catch(()=>{})
    }
    const getNivelesAcordados=()=>{
        const request:INivelRiesgo={
            skip: 0,
            take: 20,
            esAcordado: true
        }
        NivelRiesgoService.ComboNivelRiesgo(request).then((res)=>{
            if(res.status==200){
                setAcordados(res.data)
            }
        }).catch(()=>{})
    }
    const getPersonas=(personaRequest:IPersonaReporte)=>{
        HazardService.ComboPersonas(personaRequest).then((res)=>{
            if(res.status==200){
                setPersonas(res.data)
            }
        }).catch(()=>{})
    }
    const handleCardClick = (id:string) => {
        setRequest({...request,incidenteId:id});
    };
   
   
    const handlenivelClick = (id:string) => {
        setRequest({...request,nivelRiesgoId:id});
    };
    const handleAcordadoClick = (id:string) => {
        setRequest({...request,nivelRiesgoAcordadoId:id});
    };
    useEffect(()=>{
        if(requestUbicacion.search!=null|| requestUbicacion.search!=undefined){
            getUbicaciones()
        }
    },[requestUbicacion.search])
    useEffect(()=>{
        if(empresaRequest.search!=null|| empresaRequest.search!=undefined){
            getEmpresas()
        }
    },[empresaRequest.search])
     const getInfoPersona=()=>{
         HazardService.GetInfoPersonaHazard().then((res)=>{
            if(res.status==200){
                setHazardPersona(res.data)
            }
         }).catch((e)=>{})
     }
    useEffect(()=>{
        getIncidentes()
        getCondiciones()
        getActos()
        getNiveles()
        getUbicaciones()
        getEmpresas()
        getInfoPersona()
        getNivelesAcordados()
    },[])
   
    return {request,setRequest,incidentes,actos,condiciones,niveles,handleCardClick,
       handlenivelClick,requestUbicacion,setRequestUbicacion,ubicaciones,empresas,personas,setPersonaSearch,
        hazardPersona,acordados,handleAcordadoClick}
}